import React from 'react';
import { LinkCell } from '@hud/web-components/Table/Table';
import { CellContext } from '@tanstack/react-table';
import { MessageQueue } from '@hud/portal-dtos/webapp-message-queue.dto';
import { useServiceFilter } from '../../hooks/useServiceFilter';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { BreadcrumbItem } from '@hud/web-components/Breadcrumbs/Breadcrumbs';

export default function renderMessageQueueName<
  TData extends MessageQueue,
  TValue extends string,
>(topicsWithMultipleGroups: string[], referralBreadcrumbs?: BreadcrumbItem[]) {
  return function CellRenderer(cell: CellContext<TData, TValue>) {
    const updatedFilters = useServiceFilter(cell.row.original.services[0]);
    const shouldShowGroup = cell.row.original.type === 'KAFKA' && topicsWithMultipleGroups.includes(cell.getValue());
    return (
      <LinkCell
        to={`/explore/messageQueues/${cell.row.original.id}?${updatedFilters}`}
        state={{ referralBreadcrumbs: referralBreadcrumbs }}
      >
        <LongContentPopover>{`${cell.getValue()}${
          shouldShowGroup ? ` (group ${cell.row.original.groupId})` : ''
        }`}</LongContentPopover>
      </LinkCell>
    );
  };
}
